import './ServerNotificationToast.scss';

import {CloseOutlined, RightOutlined} from '@ant-design/icons';
import React from 'react';

import * as localizationKeys from '../../consts/localization/localizationKeys';
import {getTagInfo} from '../../consts/notifications/notifications';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import NotificationCategoryIcon from './NotificationCategoryIcon';

const ServerNotificationToast = ({item, onOpen, onClose}) => {
    const {name, color} = getTagInfo(item.typeCode);
    const localizedStrings = getLocalizedStrings();

    return (
        <div className='server-toast-content' style={{'--notification-color': color}}>
            <button type='button' className='server-toast-open' onClick={onOpen}>
                <span className='server-toast-icon'>
                    <NotificationCategoryIcon category={name} />
                </span>
                <span className='server-toast-copy'>
                    <span className='server-toast-category'>
                        {name || localizedStrings[localizationKeys.FILTER_NOTIFICATION_KEY_VALUE]}
                    </span>
                    <span className='server-toast-title' role='status'>
                        {item.title}
                    </span>
                    <span className='server-toast-link'>
                        {localizedStrings[localizationKeys.SERVER_NOTIFICATION_VIEW]}
                        <RightOutlined aria-hidden />
                    </span>
                </span>
            </button>
            <button
                type='button'
                className='server-toast-close'
                aria-label={localizedStrings[localizationKeys.SERVER_NOTIFICATION_CLOSE]}
                onClick={onClose}
            >
                <CloseOutlined aria-hidden />
            </button>
        </div>
    );
};

export default ServerNotificationToast;
